import styled from 'styled-components';
import { color, media, typography } from 'styles/settings';
import { ReactComponent as ShowIcon } from 'styles/icons/show-icon.svg';
import { ReactComponent as HideIcon } from 'styles/icons/hide-icon.svg';

export const PasswordRightIconContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const PasswordShowIcon = styled(ShowIcon)`
  color: ${({ theme }) => theme.secondary};
`;

export const PasswordHideIcon = styled(HideIcon)`
  color: ${({ theme }) => theme.secondary};
`;

export const PasswordRightIconText = styled.div`
  ${typography.font.medium};
  color: ${({ theme }) => theme.secondary};
  font-size: ${typography.size.sm};
  margin-left: ${typography.size.xxs};
  ${media.disableSelect}
`;
